import FieldWithButton from '@anm/components/form/FieldWithButton';
import { ChangeEvent, FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { domainsActions, domainsSelectors } from '../../../../store/modules/domains';
import { ButtonWrapper, LoaderWrapper } from './styles';

const AddDomain: FC<{ disabled: boolean }> = ({ disabled }) => {
  const dispatch = useDispatch();
  const [domain, setDomain] = useState('');
  const isAddDomainPending = useSelector(domainsSelectors.selectNewDomainPending);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => setDomain(e.target.value);

  const handleAddNewDomain = () => {
    dispatch(domainsActions.addNewDomain(domain.replace(/(^\w+:|^)\/\//, '')));
    setDomain('');
  };

  return (
    <ButtonWrapper>
      {isAddDomainPending ? (
        <LoaderWrapper size="small" color="blue" />
      ) : (
        <FieldWithButton
          value={domain}
          multirows={false}
          onChange={handleChange}
          isFieldClickable={true}
          disabled={disabled}
          onClick={handleAddNewDomain}
          placeholder="example.com"
        >
          Add new domain
        </FieldWithButton>
      )}
    </ButtonWrapper>
  );
};

export default AddDomain;
